import React from "react";
import {
  Col,
  Row,
  Input,
  Label,
  CardTitle,
  CardSubtitle,
} from "reactstrap";
// Componentes
import ButtonSpinner from "../../../../components/Buttons/ButtonSpinner";

export default function FaceRecognitionConfigList({
  configListForm,
  setConfigListForm,
  trySaveConfigs,
}) {
  if (!configListForm) {
    return null;
  }

  return (
    <div style={{ paddingBottom: "10px" }}>
      {/* {renderGeneralFields()} */}
      {renderAppearanceFields()}
      {renderColorPreview()}

      <Row
        style={{
          width: "100%",
          margin: "auto",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <ButtonSpinner
          title={"Salvar"}
          onClick={() => trySaveConfigs()}
        />
      </Row>
    </div>
  );

  function renderGeneralFields() {
    return (
      <>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label className="form-label">Sistema</Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.system}
              onChange={(e) =>
                setConfigListForm({ ...configListForm, system: e.target.value })
              }
            >
              <option value="">Selecione</option>
              <option value="mice">Mice</option>
              <option value="inteegra_eventos">Inteegra Eventos</option>
            </Input>
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label className="form-label">ID do Contrato MICE</Label>
            <Input
              className="form-control"
              type="text"
              value={configListForm.miceContractId}
              onChange={(e) =>
                setConfigListForm({ ...configListForm, miceContractId: e.target.value })
              }
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label className="form-label">Tipo de Detecção</Label>
            <Input
              className="form-control"
              type="text"
              value={configListForm.detectionType}
              onChange={(e) =>
                setConfigListForm({ ...configListForm, detectionType: e.target.value })
              }
            />
          </Col>
        </Row>
        {/* <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label className="form-label">Atributo de Foto</Label>
            <Input
              className="form-control"
              type="select"
              value={configListForm.photoAttributeId}
              onChange={(e) =>
                setConfigListForm({ ...configListForm, photoAttributeId: e.target.value })
              }
            >
              <option value="">Selecione</option>
              {attributesList &&
                attributesList.map((a, i) => (
                  <option key={i} value={a.value}>
                    {a.text}
                  </option>
                ))}
            </Input>
          </Col>
        </Row> */}
      </>
    );
  }

  function renderAppearanceFields() {
    return (
      <>
        <CardTitle>Aparência</CardTitle>
        {/* <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label className="form-label">URL Imagem de Fundo</Label>
            <Input
              className="form-control"
              type="text"
              value={configListForm.backgroundImage}
              onChange={(e) =>
                setConfigListForm({ ...configListForm, backgroundImage: e.target.value })
              }
            />
          </Col>
        </Row> */}
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label className="form-label">Cor de Fundo</Label>
            <Input
              className="form-control"
              type="text"
              value={configListForm.backgroundColor}
              onChange={(e) =>
                setConfigListForm({ ...configListForm, backgroundColor: e.target.value })
              }
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label className="form-label">Cor do Texto</Label>
            <Input
              className="form-control"
              type="text"
              value={configListForm.textColor}
              onChange={(e) =>
                setConfigListForm({ ...configListForm, textColor: e.target.value })
              }
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label className="form-label">Cor de Fundo do Botão</Label>
            <Input
              className="form-control"
              type="text"
              value={configListForm.buttonBackgroundColor}
              onChange={(e) =>
                setConfigListForm({ ...configListForm, buttonBackgroundColor: e.target.value })
              }
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <Label className="form-label">Cor do Texto do Botão</Label>
            <Input
              className="form-control"
              type="text"
              value={configListForm.buttonTextColor}
              onChange={(e) =>
                setConfigListForm({ ...configListForm, buttonTextColor: e.target.value })
              }
            />
          </Col>
        </Row>
      </>
    );
  }

  function renderColorPreview() {
    return (
      <div style={{ paddingBottom: 10 }}>
        <CardSubtitle>Exemplo</CardSubtitle>
        <div
          style={{
            backgroundColor: configListForm.backgroundColor || "white",
            width: "100%",
            padding: "10px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              fontSize: 17,
              color: configListForm.textColor || "black",
              fontFamily: "verdana",
              marginBottom: 8,
            }}
          >
            EXEMPLO DE TEXTO
          </div>
          <div
            style={{
              alignItems: "center",
              backgroundColor: configListForm.buttonBackgroundColor,
              padding: "8px",
              borderRadius: "5px",
              color: configListForm.buttonTextColor,
              fontFamily: "verdana",
              fontSize: 16,
              textAlign: "center",
            }}
          >
            EXEMPLO BOTÃO
          </div>
        </div>
      </div>
    );
  }
}
